import { render, staticRenderFns } from "./ChoosePlanetSlide.vue?vue&type=template&id=39925890"
import script from "./ChoosePlanetSlide.vue?vue&type=script&lang=js"
export * from "./ChoosePlanetSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39925890')) {
      api.createRecord('39925890', component.options)
    } else {
      api.reload('39925890', component.options)
    }
    module.hot.accept("./ChoosePlanetSlide.vue?vue&type=template&id=39925890", function () {
      api.rerender('39925890', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/student/vue/slides/ChoosePlanetSlide.vue"
export default component.exports